__webpack_require__.S = {};
const initPromises = {};
const initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	let initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	const scope = __webpack_require__.S[name];
	const warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	const uniqueName = "gaxl-web-host";
	const register = (name, version, factory, eager) => {
		const versions = scope[name] = scope[name] || {};
		const activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	const initExternal = (id) => {
		const handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			const module = __webpack_require__(id);
			if(!module) return;
			const initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			const initResult = initFn(module);
			if(initResult?.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	const promises = [];
	switch(name) {
		case "default": {
			register("@growthaxl/web-foundation", "0.1.31", () => (() => (__webpack_require__(8384))), 1);
			register("i18next", "25.10.10", () => (() => (__webpack_require__(2635))), 1);
			register("react-dom", "19.2.7", () => (() => (__webpack_require__(961))), 1);
			register("react-i18next", "15.7.4", () => (() => (__webpack_require__(2389))), 1);
			register("react-router-dom", "6.30.4", () => (() => (__webpack_require__(2648))), 1);
			register("react", "19.2.7", () => (() => (__webpack_require__(6540))), 1);
			register("zustand/react/shallow", "5.0.14", () => (() => (__webpack_require__(3525))), 1);
			register("zustand/react", "5.0.14", () => (() => (__webpack_require__(1323))), 1);
			register("zustand", "5.0.14", () => (() => (__webpack_require__(7282))), 1);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};